import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Utils } from 'src/app/core/resources/utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { VehicleInspect } from 'src/app/core/interfaces/vehicleInspect';
import { CargoItemService } from 'src/app/modules/cargo/cargo-item/cargo-item.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DialogComponent } from '../dialog/dialog.component';
import { VehiclesService } from 'src/app/modules/administration/vehicles/list-vehicles.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileStorage } from 'src/app/core/interfaces/fileStorage';
import { AngularFireStorage } from '@angular/fire/storage';
import { VehicleDocuments } from 'src/app/core/interfaces/vehicleDocuments';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import ContentTypes from 'src/app/core/resources/content-type-ext.json';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { ResourceMessages } from 'src/app/core/messages/resource-messages.enum';
import { CheckLists } from 'src/app/core/interfaces/checkListsInspectVehicle';
import { KeyValue } from '@angular/common';
import { ProtectionElements } from 'src/app/core/interfaces/protectionElementInspectVehicle';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DateManager } from 'src/app/core/managers/date.manager';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { BasicPerson } from 'src/app/core/interfaces/basicPerson';
import { Global } from 'src/app/core/resources/global';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { InspectionQuestion, InspectionVisualQuestion } from 'src/app/core/interfaces/inspectionVehicle';
import { AuthService } from 'src/app/core/services/authentication.service';
import { AdminUsersService } from 'src/app/modules/administration/admin-users/admin-users.service';
import { InspectionDocumentComponent, InspectionDocumentData } from 'src/app/modules/cargo/inspection-document/inspection-document.component';
import { StorageEndpoints } from 'src/app/core/resources/storage-endpoints';
import { Fmt } from 'src/app/core/messages/fmt';
import { FileService } from 'src/app/shared/files/file.service';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Subscription } from 'rxjs';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';

@Component({
  selector: 'app-dialog-survey',
  templateUrl: './dialog-survey.component.html',
  styleUrls: ['./dialog-survey.component.scss'],
})
export class DialogSurveyComponent implements OnInit {
  permission = Permission;
  public options = { "B": "Bueno", "M": "Malo", "N/A": "No Aplica" };
  public motorcycleOptions = { "B": "C", "M": "NC", "N/A": "N/A" };
  public motorcycleOptionsAlias = { "C": "Cumple", "NC": "No cumple", "N/A": "No Aplica" };
  public readonly hoursAwakeOptions = ["1 hora o menos", "2 horas", "3 horas", "4 horas", "5 horas", "6 horas", "7 horas", "8 horas", "9 horas", "10 horas", "11 horas", "12 horas o más"];
  public sections = this.utils.clone(this.global.dialogSurveySections);

  public vehicleStructure: Array<CheckLists> = [];
  public bodyworkElements: Array<CheckLists> = [];
  public elements: Array<ProtectionElements> = [];

  public isMotorcycle = false;
  public inspection: 'motorcycle' | 'cargoVehicle' = 'cargoVehicle';
  public version: number = 0;
  public inspectionQuestions: {
    [key: string]: Array<InspectionVisualQuestion>
  } = {};
  public getQuestionFlag = false;

  public optimal: boolean = false;
  public odors: boolean = false;
  public crossedContamination: boolean = false;
  public fatigueTestForm: FormGroup = new FormGroup({
    hoursAwake: new FormControl(null, Validators.required),
    hoursOfSleep: new FormControl(null, Validators.required),
    takingSleepMedications: new FormControl(null, Validators.required),
    optimalHealthToDrive: new FormControl(null, Validators.required),
  });

  public user: string;
  public vehicle: Vehicle;
  basePath: string;
  public updatePhoto: boolean = false;
  public objComplete: VehicleInspect;
  public loadingImages: boolean = false;
  minObservation: number = 8;
  @ViewChild('inputLeftLateralPicture') inputLeftLateralPicture: ElementRef;
  @ViewChild('inputRightLateralPicture') inputRightLateralPicture: ElementRef;
  @ViewChild('inputFrontalImage') inputFrontalImage: ElementRef;
  @ViewChild('inputPreventativeMaintenance') inputPreventativeMaintenance: ElementRef;
  @ViewChild('inputCorrectiveMaintenance') inputCorrectiveMaintenance: ElementRef;
  @ViewChild(InspectionDocumentComponent) inspectionDocumentComponent: InspectionDocumentComponent;
  form = new FormGroup({
    observation: new FormControl(''),
    dateMaintenanceCorrective: new FormControl('', Validators.required),
    dateMaintenancePreventive: new FormControl('', Validators.required),
    driverWarranty: new FormControl(false, Validators.required),
  });
  instanceLogo: FileStorage;
  formPicture = new FormGroup({
    frontPicture: new FormControl('', Validators.required),
    rightLateralPicture: new FormControl('', Validators.required),
    leftLateralPicture: new FormControl('', Validators.required),
    preventativeMaintenance: new FormControl(''),
    correctiveMaintenance: new FormControl(''),
  });

  noElementQuestionWithOnlyObservation = ['CEU'];
  sectionDoesNotApplyByDefault = ['inspeccion de cisterna'];
  public originalOrder = (a, b): number => 0;
  resourcesPath: { url: string, type: string, field: string }[] = [];
  public typeOfInspection: 'form' | 'document' = 'form';
  public selectedDocument: InspectionDocumentData | null = null;

  constructor(
    public dialogRef: MatDialogRef<DialogSurveyComponent>,
    private authService: AuthService,
    private snackBarService: SnackBarService,
    public utils: Utils,
    private cargoItemService: CargoItemService,
    public dialog: MatDialog,
    private vehiclesService: VehiclesService,
    private spinner: NgxSpinnerService,
    private global: Global,
    private angularFireStorage: AngularFireStorage,
    private adminUsersService: AdminUsersService,
    private fileService: FileService,
    private permissionRole: PermissionRole,
    @Inject(MAT_DIALOG_DATA) public data: {
      user?: BasicPerson,
      licensePlate?: string,
      inspect?: VehicleInspect,
      disabled?: boolean,
      id?: string,
      cargo?: Cargo,
      typeOfInspection?: 'form' | 'document'
    }
  ) { }

  public approvalUserInformation: string;
  public createdUserInformation: string;
  public approvalUserControl: FormControl = new FormControl({ value: '', disabled: true });
  public changeApprovalUser: boolean = false;
  public optionsDocumentUser: OptionsAutocomplete = {
    title: 'N° de identificación del aprobador',
    filterBy: 'userClient',
  }
  public changeApprovalUserControl: FormControl = new FormControl('', Validators.required);
  public changeApprovalUserSub: Subscription;
  public approvalUser = {
    name: '',
    document: ''
  }

  async ngOnInit() {
    if (this.data.typeOfInspection)
      this.typeOfInspection = this.data.typeOfInspection;
    await this.getInspectionQuestions();

    if (this.data.inspect && this.data.inspect.id) {
      this.form.patchValue(this.data.inspect);
      this.form.get('dateMaintenancePreventive').setValue(DateManager.stringToDate(this.data.inspect.dateMaintenancePreventive, 'YYYY-MM-DD'));
      this.form.get('dateMaintenanceCorrective').setValue(DateManager.stringToDate(this.data.inspect.dateMaintenanceCorrective, 'YYYY-MM-DD'));
      if (this.data.inspect.preventativeMaintenance) {
        this.formPicture.get("preventativeMaintenance").setValue(this.data.inspect.preventativeMaintenance);
        this.formPicture.get("preventativeMaintenance").disable();
      }
      if (this.data.inspect.correctiveMaintenance) {
        this.formPicture.get("correctiveMaintenance").setValue(this.data.inspect.correctiveMaintenance);
        this.formPicture.get("correctiveMaintenance").disable();
      }

      this.bodyworkElements = this.data.inspect.bodyworkElements;
      this.elements = this.data.inspect.elements;
      this.vehicleStructure = this.data.inspect.vehicleStructure;

      if (this.data.inspect.hoursAwake)
        this.fatigueTestForm.get('hoursAwake').setValue(this.data.inspect.hoursAwake);
      if (this.data.inspect.hoursOfSleep)
        this.fatigueTestForm.get('hoursOfSleep').setValue(this.data.inspect.hoursOfSleep);
      if (this.utils.isDefined(this.data.inspect.takingSleepMedications))
        this.fatigueTestForm.get('takingSleepMedications').setValue(this.data.inspect.takingSleepMedications);
      if (this.utils.isDefined(this.data.inspect.optimalHealthToDrive))
        this.fatigueTestForm.get('optimalHealthToDrive').setValue(this.data.inspect.optimalHealthToDrive);
      this.fatigueTestForm.disable();

      if (this.data.inspect.confirmedInspectionFingerPrint && this.utils.isDefined(this.data.inspect.approval))
        this.approvalUserInformation = this.data.inspect.confirmedInspectionFingerPrint.userName;
      if (this.data.inspect.evaluatorFingerPrint)
        this.createdUserInformation = this.data.inspect.evaluatorFingerPrint.userName;
      this.form.disable();
    }
    else
      this.createdUserInformation = this.data.user.name;
    this.approvalUser.name = this.data.user.name;
    this.approvalUser.document = this.data.user.document;
    this.approvalUserControl.setValue(this.approvalUser.name);
    this.changeApprovalUserSub = this.changeApprovalUserControl.valueChanges.subscribe(value => {
      if (value && value.information && value.information.document) {
        this.approvalUserControl.setValue(value.information.name);
        this.approvalUser.name = value.information.name;
        this.approvalUser.document = value.information.document;
        this.changeApprovalUser = false;
      }
    });
    this.getVehicle(this.data.licensePlate);
  }

  private async getInspectionQuestions() {
    this.isMotorcycle = this.data.cargo && this.utils.getNestedValue(this.data.cargo, 'cargoFeature.vehicleType.name') === 'MOTOCICLETA';
    const hasMotorcycleInspection = this.data.inspect && this.data.inspect.inspectionType === 'motorcycle';

    this.version = this.data.inspect && this.data.inspect.version === 2 ? 2 : 3;
    this.inspection = this.isMotorcycle || hasMotorcycleInspection ? 'motorcycle' : 'cargoVehicle';

    let questions: InspectionQuestion[] = [];
    try {
      questions = await this.cargoItemService.getInspectionQuestions(this.inspection, this.version).toPromise();
    } catch (e) { }

    if (!questions || !questions.length) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      return this.dialogRef.close();
    }

    if (this.inspection === 'motorcycle') //Inspección de moto (v2)
      this.inspectionQuestions = {
        "condiciones del usuario": [],
        "verificacion del sistema electrico": [],
        "estado mecanico": [],
        "estado de funcionamiento del motor": [],
      };
    else if (this.version === 2) //Inspección de vehículo antigua (v2)
      this.inspectionQuestions = {
        "estructura del vehiculo": [],
        "carroceria": [],
        "elementos de proteccion personal": []
      };
    else //Inspección de vehículo nueva (v3)
      this.inspectionQuestions = {
        "estado general y cabina": [],
        "sistema electrico": [],
        "sistema mecanico": [],
        "equipo de seguridad": [],
        "inspeccion a la unidad de carga": [],
        "inspeccion de cisterna": [],
        "elementos de proteccion personal": [],
      };

    questions.forEach(question => {
      let questionToAdd = {};
      const section = question.mobileSection ? question.mobileSection : question.section;
      if (question && question.code && question.inspectionAttribute && section && this[question.inspectionAttribute]) {

        if (question.inspectionAttribute === 'elements') {
          questionToAdd['name'] = question.code;
          questionToAdd['available'] = true;
          questionToAdd['status'] = this.isVehicleInspectionv3 ? 'C' : 'B';
        } else {
          questionToAdd['question'] = question.code;
          if (!this.noElementQuestionWithOnlyObservation.includes(question.code))
            questionToAdd['response'] = this.isVehicleInspectionv3 ? this.sectionDoesNotApplyByDefault.includes(section) ? 'N/A' : 'C' : 'B';
          questionToAdd['observation'] = '';
        }
        if (this.inspection === 'motorcycle')
          questionToAdd['observation'] = '';

        this[question.inspectionAttribute].push(questionToAdd);
        if (this.inspectionQuestions[section]) {
          if (question.sectionName || question.componentName)
            this.sections[section] = question.sectionName ? question.sectionName : question.componentName;
          this.inspectionQuestions[section].push({
            code: question.code,
            name: question.question,
            description: question.description,
            inspectionAttribute: question.inspectionAttribute,
            hasResponse: 'response' in questionToAdd,
            hasStatus: 'status' in questionToAdd,
            hasObservation: 'observation' in questionToAdd,
            hasAvailable: 'available' in questionToAdd,
            order: question.order
          });
        }
      }
    });

    Object.keys(this.inspectionQuestions).forEach(key => {
      this.inspectionQuestions[key].sort((a, b) => {
        if (a.order > b.order) return 1;
        else return -1
      })
    });

    this.getQuestionFlag = true;
  }

  public getVehicle(id: string) {
    this.vehiclesService.getVehicleFromOwnCompany(id).subscribe(
      (success: any) => {
        if (success) {
          this.vehicle = success;
          this.formPicture.patchValue(this.vehicle);
          this.loadingImages = true;
          const vehicleInspectionPromises = Object.keys(this.formPicture.value)
            .filter(key => this.formPicture.value[key])
            .map(key => {
              const value = this.formPicture.value[key];
              return this.adminUsersService.searchResourceDynamicallyAmongCompanies(value, 'image', null, true, key);
            });

          Promise.all(vehicleInspectionPromises).then(results => {
            this.resourcesPath = results.filter(result => result !== null);
          }).catch(() => {
            this.resourcesPath = [];
          }).finally(() => this.loadingImages = false);
          if (this.data && this.data.inspect && this.data.inspect.id) {
            this.formPicture.disable();
          }
        }
      }
    );
  }

  public setNewApprovalUser(change: boolean) {
    this.changeApprovalUser = change;
  }

  public onFileSelected(documentData: InspectionDocumentData) {
    this.selectedDocument = documentData;
  }

  public confirmRejection() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `¿Estás seguro que deseas rechazar la inspección del vehiculo?`,
    };
    dialogConfig.height = 'auto';
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.state) {
        this.approve(false);
      }
    });
  }

  public approve(approval: boolean) {
    let obj = {
      inspectionId: this.data.inspect.id,
      fingerprint: {
        userId: this.approvalUser.document,
        userName: this.approvalUser.name,
        date: DateManager.dateToString(new Date())
      }
    };
    this.cargoItemService.approveInspection(obj, approval).subscribe(success => {
      approval ?
        this.snackBarService.openSnackBar('Inspección aprobada correctamente', undefined, "success") :
        this.snackBarService.openSnackBar('Inspección rechazada correctamente', undefined, "success");
      this.dialogRef.close();
    },
      (error: HttpErrorResponse) => {
        if (!this.utils.isEmpty(error) && !this.utils.isEmpty(error.error) && !this.utils.isEmpty(error.error.message)) {
          this.snackBarService.openSnackBar(error.error.message, undefined, 'alert');
        } else {
          this.snackBarService.openSnackBar('Ocurrió un error al aprobar inspección', undefined, 'error');
        }
      }
    );
  }

  public setInstanceFileStorage(e: Event, typeFile?: string) {
    const validTypeFiles = ['rightLateralPicture', 'leftLateralPicture', 'frontPicture', 'correctiveMaintenance', 'preventativeMaintenance'];
    if (['rightLateralPicture', 'leftLateralPicture', 'frontPicture'].includes(typeFile))
      this.updatePhoto = true;
    if (validTypeFiles.includes(typeFile)) {
      if (this.utils.isImage(e.target['files'])) {
        this.instanceLogo = {
          fileData: {
            file: e.target['files'][0],
            name: e.target['files'][0]['name'],
            uploaded: true,
            size: this.utils.bytesToSize(e.target['files'][0].size),
            url: null
          },
          storageData: {
            storageRef: null,
            uploadTask: null,
            uploadProgress: null
          }
        };
        this.uploadFileStorage(typeFile);
      } else {
        this.snackBarService.openSnackBar('El archivo no es una imagen', undefined, 'error')
      }
    } else {
      this.instanceLogo = {
        fileData: {
          file: e.target['files'][0],
          name: e.target['files'][0]['name'],
          uploaded: true,
          size: this.utils.bytesToSize(e.target['files'][0].size),
          url: null
        },
        storageData: {
          storageRef: null,
          uploadTask: null,
          uploadProgress: null
        }
      };
      this.uploadFileStorage(typeFile);
    }
  }

  public openWindowFile(typeFile?: string): void {
    if (typeFile == 'leftLateralPicture' && this.formPicture.get('leftLateralPicture').enabled) {
      this.inputLeftLateralPicture.nativeElement.click();
    }
    if (typeFile == 'rightLateralPicture' && this.formPicture.get('rightLateralPicture').enabled) {
      this.inputRightLateralPicture.nativeElement.click();
    }
    if (typeFile == 'frontPicture' && this.formPicture.get('frontPicture').enabled) {
      this.inputFrontalImage.nativeElement.click();
    }
    if (typeFile == 'preventativeMaintenance' && this.formPicture.get('preventativeMaintenance').enabled) {
      this.inputPreventativeMaintenance.nativeElement.click();
    }
    if (typeFile == 'correctiveMaintenance' && this.formPicture.get('correctiveMaintenance').enabled) {
      this.inputCorrectiveMaintenance.nativeElement.click();
    }
  }

  private uploadFileStorage(typeFile?: string): void {
    this.basePath = 'vehicle/' + this.vehicle.id + '/';
    let filePath = this.basePath + this.instanceLogo.fileData.name;
    const fileTypeToField = {
      rightLateralPicture: 'rightLateralPicture',
      leftLateralPicture: 'leftLateralPicture',
      frontPicture: 'frontPicture',
      preventativeMaintenance: 'preventativeMaintenance',
      correctiveMaintenance: 'correctiveMaintenance'
    };
    if (fileTypeToField[typeFile]) {
      this.formPicture.get(fileTypeToField[typeFile]).setValue(filePath);
    }
    this.spinner.show();
    this.instanceLogo.storageData.storageRef = this.angularFireStorage.ref(filePath);
    this.instanceLogo.storageData.uploadTask = this.angularFireStorage.upload(filePath, this.instanceLogo.fileData.file);
    this.instanceLogo.storageData.uploadTask.then(
      (data) => {
        this.instanceLogo.storageData.storageRef.getDownloadURL().subscribe(
          (urlFile) => {
            this.spinner.hide();
          }
        );
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  // Método para subir el documento seleccionado
  public async uploadSelectedDocument(): Promise<{ success: boolean, fileName: string }> {
    if (!this.selectedDocument) {
      this.snackBarService.openSnackBar('No se ha subido ningún documento', undefined, 'alert');
      return { success: false, fileName: null };
    }
    const path = Fmt.string(StorageEndpoints.cargoVehicleChecklist, this.data.id);
    try {
      const file = this.selectedDocument && this.selectedDocument.file ? this.selectedDocument.file : null;
      if (!file) return { success: false, fileName: null };
      const success = await this.fileService.loadFileToStorage(path, file.name, file)
      if (!success) {
        this.snackBarService.openSnackBar(Fmt.string(ResourceMessages.ERROR_UPLOAD, 'el documento'), undefined, 'error');
        return { success: false, fileName: null };
      }
      return { success: true, fileName: file.name };
    } catch (error) {
      this.snackBarService.openSnackBar('Ocurrió un error al cargar el documento', undefined, 'error');
      return { success: false, fileName: null };
    }
  }

  saveInspection() {
    this.form.markAllAsTouched();
    if (this.typeOfInspection === 'document' && !this.selectedDocument)
      return this.snackBarService.openSnackBar('No se ha subido ningún documento', undefined, 'alert');
    else if (this.showFatigueTest && (!this.fatigueTestForm.valid))
      return this.snackBarService.openSnackBar('Debe completar todos los campos del test de fatiga del conductor', undefined, 'alert');
    else if (this.utils.errorMessagesCustomized(this.form.get('dateMaintenanceCorrective'), 'fecha de mantenimiento correctivo')) return;
    else if (this.utils.errorMessagesCustomized(this.form.get('dateMaintenancePreventive'), 'fecha de mantenimiento preventivo')) return;
    else if (this.utils.errorMessagesCustomized(this.form.get('observation'), 'observación', 8)) return;
    else if (this.isVehicleInspectionv3 && !this.form.get('driverWarranty').value)
      return this.snackBarService.openSnackBar('Debe aceptar la garantía de responsabilidad', undefined, 'alert');
    else if (this.form.invalid)
      return this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, 'alert');
    else {
      let objUser = {
        userId: this.data.user.document,
        userName: this.data.user.name,
        date: DateManager.dateToString(new Date())
      }

      const dateMaintenancePreventive = DateManager.dateToString(this.form.get('dateMaintenancePreventive').value, 'YYYY-MM-DD');
      const dateMaintenanceCorrective = DateManager.dateToString(this.form.get('dateMaintenanceCorrective').value, 'YYYY-MM-DD');
      this.objComplete = {
        version: this.version,
        confirmedInspectionFingerPrint: null,
        rejectionCause: null,
        licensePlate: this.data.licensePlate,
        vehicleStructure: this.vehicleStructure,
        bodyworkElements: this.bodyworkElements,
        elements: this.elements,
        evaluatorFingerPrint: objUser,
        observation: this.form.get('observation').value,
        dateMaintenancePreventive,
        dateMaintenanceCorrective,
        driverWarranty: this.form.get('driverWarranty').value,
        optimal: this.optimal,
        odors: this.odors,
        crossedContamination: this.crossedContamination,
        preventativeMaintenance: this.formPicture.value.preventativeMaintenance,
        correctiveMaintenance: this.formPicture.value.correctiveMaintenance,
        inspectionType: this.isMotorcycle ? 'motorcycle' : 'cargoVehicle',
      };
      if (this.showFatigueTest) {
        this.objComplete['hoursAwake'] = this.fatigueTestForm.value.hoursAwake;
        this.objComplete['hoursOfSleep'] = this.fatigueTestForm.value.hoursOfSleep;
        this.objComplete['takingSleepMedications'] = this.fatigueTestForm.value.takingSleepMedications;
        this.objComplete['optimalHealthToDrive'] = this.fatigueTestForm.value.optimalHealthToDrive;
      }

      if (!this.updatePhoto) {
        this.spinner.show();
        this.save();
      } else {
        //  Aqui va la parte de la subida de las fotos
        if (this.utils.errorMessagesCustomized(this.formPicture.get('frontPicture'), 'foto frontal del vehículo')) return;
        else if (this.utils.errorMessagesCustomized(this.formPicture.get('rightLateralPicture'), 'foto lateral derecha del vehículo')) return;
        else if (this.utils.errorMessagesCustomized(this.formPicture.get('leftLateralPicture'), 'foto lateral izquierda del vehículo')) return;
        else if (this.utils.errorMessagesCustomized(this.formPicture.get('preventativeMaintenance'), 'foto mantenimiento preventivo')) return;
        else if (this.utils.errorMessagesCustomized(this.formPicture.get('correctiveMaintenance'), 'foto mantenimiento correctivo')) return;
        else if (this.formPicture.invalid) {
          this.snackBarService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, 'alert');
          return;
        } else {
          this.spinner.show();
          //Para propertyCard toca buscar esa info para cargarla antes de guardar;
          const data: VehicleDocuments = {
            frontPicture: this.formPicture.value.frontPicture,
            rightLateralPicture: this.formPicture.value.rightLateralPicture,
            leftLateralPicture: this.formPicture.value.leftLateralPicture,
            propertyCard: this.vehicle.propertyCard,
          }
          this.vehiclesService.updateVehicleDocuments(this.vehicle.id, data).subscribe(
            (success: any) => this.save(),
            (error) => {
              this.spinner.hide();
              this.snackBarService.openSnackBar('Ocurrió un error al guardar los datos', undefined, 'error');
            }
          );
        }
      }
    }
  }

  public async save() {
    if (this.typeOfInspection === 'document' && this.selectedDocument) {
      const { success, fileName } = await this.uploadSelectedDocument();
      if (!success) {
        this.spinner.hide();
        return this.snackBarService.openSnackBar(Fmt.string(ResourceMessages.ERROR_UPLOAD, 'el documento'), undefined, 'error');
      }
      this.objComplete['inspectionDocument'] = fileName;
    }
    this.cargoItemService.sendInspection(this.objComplete, this.isMotorcycle ? "motorcycle" : "VEHICLE", this.data.id).subscribe(
      (success) => {
        this.spinner.hide();
        if (success) {
          this.snackBarService.openSnackBar('Inspección guardada correctamente');
          this.closeDialog(success);
        } else {
          this.snackBarService.openSnackBar('Existio un error al guardar la inspección', undefined, 'error');
          this.closeDialog('');
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        if (!this.utils.isEmpty(error) && !this.utils.isEmpty(error.error) && !this.utils.isEmpty(error.error.message)) {
          this.snackBarService.openSnackBar(error.error.message, undefined, 'alert');
        } else {
          this.snackBarService.openSnackBar('Ocurrió un error al enviar inspeción', undefined, 'error');
        }
      }
    );
  }
  public downloadInspection() {
    if (this.typeOfInspection === 'document' && this.data.inspect && this.data.inspect.id && this.data.inspect.inspectionDocument) {
      if (this.inspectionDocumentComponent)
        this.inspectionDocumentComponent.downloadDocument();
      else this.snackBarService.openSnackBar(
        Fmt.string(ResourceMessages.ERROR_DOWNLOAD, 'la inspección preoperacional del vehículo'), undefined, 'error');
      return;
    }
    this.spinner.show();
    this.cargoItemService.getInspectionPDF(this.data.id, this.data.licensePlate).subscribe(
      (response) => {
        this.spinner.hide();
        var file = new Blob([response], { type: ContentTypes.pdf });
        var downloadURL = window.URL.createObjectURL(file);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = `_${this.data.licensePlate}_Inspección-preoperacional-vehicular.pdf`;
        link.click();
      }, (error: HttpErrorResponse) => {
        this.spinner.hide()
        this.snackBarService.openSnackBar(
          Fmt.string(ResourceMessages.ERROR_DOWNLOAD, 'la inspección preoperacional del vehículo'), undefined, 'error');
      })
  }

  closeDialog(object) {
    this.dialogRef.close(object);
  }

  getArrayByName(name: "vehicleStructure" | "bodyworkElements" | "elementsProtection") {
    return this[name];
  }
  getQuestionIndex(code: string, list: "vehicleStructure" | "bodyworkElements" | "elementsProtection"): number {
    return this[list].findIndex((question: ProtectionElements | CheckLists) =>
      question && (('name' in question && question.name === code) || ('question' in question && question.question === code))
    );
  }
  get getRealOptions(): Array<string> {
    if (!this.getQuestionFlag) return [];
    if (this.isVehicleInspectionv3) return ["C", "NC", "N/A"];
    return ["B", "M", "N/A"];
  }

  getAliasOption(option: string): string {
    if (this.options[option]) return this.options[option];
    if (this.motorcycleOptionsAlias[option]) return this.motorcycleOptionsAlias[option];
    return option;
  }

  get useQuestionAlias(): boolean {
    return this.inspection === 'motorcycle';
  }
  get isVehicleInspectionv3(): boolean {
    return this.inspection === 'cargoVehicle' && this.version === 3;
  }
  get showFatigueTest(): boolean {
    const previousInspectionId = this.utils.getNestedValue(this.data, 'inspect.id');
    const hasFatigueTest = this.utils.getNestedValue(this.data, 'inspect.hoursAwake');
    return this.typeOfInspection === 'form' && this.version === 3 && (!previousInspectionId || hasFatigueTest);
  }

  showQuestionLabel(visualQuestion: InspectionVisualQuestion): boolean {
    return !this.isVehicleInspectionv3 || (this.isVehicleInspectionv3 && !visualQuestion.hasAvailable);
  }
  showQuestionAvailable(visualQuestion: InspectionVisualQuestion): boolean {
    return visualQuestion.hasAvailable && !this.isMotorcycle && this.getQuestionIndex(
      visualQuestion.code,
      visualQuestion.inspectionAttribute as "vehicleStructure" | "bodyworkElements" | "elementsProtection"
    ) !== -1;
  }
  showQuestionStatus(visualQuestion: InspectionVisualQuestion): boolean {
    return visualQuestion.hasStatus && !this.isVehicleInspectionv3 && this.getQuestionIndex(
      visualQuestion.code, visualQuestion.inspectionAttribute as "vehicleStructure" | "bodyworkElements" | "elementsProtection") !== -1;
  }
  showQuestionResponse(visualQuestion: InspectionVisualQuestion): boolean {
    return visualQuestion.hasResponse && this.getQuestionIndex(
      visualQuestion.code, visualQuestion.inspectionAttribute as "vehicleStructure" | "bodyworkElements" | "elementsProtection") !== -1;
  }
  showQuestionObservation(visualQuestion: InspectionVisualQuestion): boolean {
    const attribute = visualQuestion.inspectionAttribute as "vehicleStructure" | "bodyworkElements" | "elementsProtection";
    const hasObservationFromMobile = !!this.getArrayByName(attribute)[this.getQuestionIndex(visualQuestion.code, attribute)].observation;
    const mustShowObservation = this.inspection === 'motorcycle' ||
      (attribute !== 'elementsProtection' && this.noElementQuestionWithOnlyObservation.includes(visualQuestion.code));
    return visualQuestion.hasObservation && (mustShowObservation || hasObservationFromMobile) &&
      this.getQuestionIndex(visualQuestion.code, attribute) !== -1;
  }
  get userName(): string {
    const evaluatorUserName = this.utils.getNestedValue(this.data.inspect, 'evaluatorFingerPrint.userName');
    if (evaluatorUserName) return evaluatorUserName;
    return this.authService && this.authService.getUserSession().information.name;
  }
  get vehiclePlate(): string {
    return this.data.licensePlate;
  }
  get canApproveInspection(): boolean {
    const hasInspection = this.utils.getNestedValue(this.data, 'inspect.id');
    const hasApproval = this.utils.getNestedValue(this.data, 'inspect.approval');
    const hasPermissionApproveRejected = this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.approveRejectedInspection);
    return hasInspection && (!this.utils.isDefined(hasApproval) || (!hasApproval && hasPermissionApproveRejected));
  }
  get canRejectInspection(): boolean {
    const hasInspection = this.utils.getNestedValue(this.data, 'inspect.id');
    const hasApproval = this.utils.getNestedValue(this.data, 'inspect.approval');
    return hasInspection && !this.utils.isDefined(hasApproval);
  }

  getResourcesPathByTypeFile(field: string): { url: string, type: string, field: string } | undefined {
    return this.resourcesPath.find(resource => resource.field === field);
  }

  ngOnDestroy() {
    if (this.changeApprovalUserSub) this.changeApprovalUserSub.unsubscribe();
  }

}
